import "@/App.css";
import { ArrowRight } from "lucide-react";

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col items-center justify-center px-6" data-testid="coming-soon-page">
      {/* Logo */}
      <div className="flex items-center gap-0.5 mb-8">
        <img src="/logo.png" alt="PrevantEdge Logo" className="w-12 h-12 -mr-1" />
        <span 
          className="text-3xl font-bold text-[#1A1A1A]" 
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          PrevantEdge<sup className="text-sm">™</sup>
        </span>
      </div>

      {/* Main Content */}
      <div className="text-center max-w-xl">
        <h1 
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1A1A1A] mb-6"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Coming Soon
        </h1>
        
        <p className="text-lg text-[#666] mb-8 leading-relaxed">
          We're building something special — proactive employee benefits that give your business the competitive edge in attracting and retaining top talent.
        </p>

        {/* CTA */}
        <a 
          href="mailto:info@prevantedgeplan.com" 
          className="inline-flex items-center gap-2 bg-[#2E5C55] text-white hover:bg-[#2E5C55]/90 rounded-full px-8 py-4 text-lg font-medium transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5"
          data-testid="contact-button"
        >
          Get Notified
          <ArrowRight className="w-5 h-5" />
        </a>
      </div>

      {/* Footer */}
      <div className="absolute bottom-8 text-center">
        <p className="text-sm text-[#999]">
          © {new Date().getFullYear()} PrevantEdge™. All rights reserved.
        </p>
      </div>
    </div>
  );
};

function App() {
  return <ComingSoon />;
}

export default App;
